import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button, CircularProgress, Link } from '@mui/material';
import React, { useState } from 'react';
import { LoadState } from '../types/LoadState';
import * as AktClient from './AktClient';
import { MetriaAktMetadata } from './types/MetriaAktMetadata';

interface NedladdningslankarProps {
  akt: MetriaAktMetadata;
}

const Nedladdningslankar: React.FC<
  React.PropsWithChildren<NedladdningslankarProps>
> = ({ akt }) => {
  const [downloadingLoadState, setDownloadingLoadState] = useState(
    LoadState.Idle
  );
  const isActive =
    akt.status === 'HAMTAD' && downloadingLoadState !== LoadState.Loading;

  const getLink = (akt: MetriaAktMetadata): string => `/akter/${akt.id}`;

  return (
    <Link
      href={getLink(akt)}
      sx={{
        textDecoration: 'none',
        ...(isActive ? {} : { cursor: 'default' }),
      }}
      onClick={async (e: React.MouseEvent) => {
        e.preventDefault();
        if (!isActive) {
          return;
        }

        setDownloadingLoadState(LoadState.Loading);

        (await AktClient.downloadAkt(akt.id.toString())).downloadBlob(
          `${akt.aktbeteckning}.${akt.format.toLocaleLowerCase()}`
        );
        setDownloadingLoadState(LoadState.Idle);
      }}
    >
      <Button
        sx={{ mt: -0.5, mb: -0.5 }}
        disabled={!isActive}
        size="small"
        endIcon={
          isActive ? <FileDownloadIcon /> : <CircularProgress size={16} />
        }
      >
        {akt.format}
      </Button>
    </Link>
  );
};

export default Nedladdningslankar;

